import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { commonErrorMessage, companyErrorPageMessage } from 'src/app/constants/error-message-constant';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { AdminType } from 'src/app/enum/question-enum';
import { CompanyConstant } from 'src/app/constants/label-constants';
import { CommonConstant } from 'src/app/constants/common-constant';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})

export class CompanyProfileComponent implements OnInit {
  files!: File;
  imageURL: any;
  filesPhoto: any[] | undefined;
  CompanyPhoto: any;
  CompanyForm: FormGroup = this.formBuilder.group({});
  companyId: number = 0;
  commonConstant: any = [];
  submittedCompanydetail = false;
  CompanyConstant: any = [];
  flag: boolean = false;
  companyLogo: string = '';
  errorMessage: any = [];
  commonErrorMessage: any = [];
  userPhotoFile: any;
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.CompanyForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  constructor(private commonService: CommonService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    private storageService: StorageService,
    private router: Router,
    private sharedService: SharedService,) { }

  ngOnInit() {
    this.CompanyConstant = CompanyConstant;
    this.commonConstant = CommonConstant;
    this.errorMessage = companyErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.sharedService.setData('Company Profile');
    if (localStorage.getItem('authToken')) {
      const roleId = this.authService.getAdminRoleId();
      if (roleId == AdminType.CompanyAdmin) {
        this.companyId = Number(this.storageService.getValue('companyId'));
      }
    }
    this.spinner.show();
    this.onInitCompanyForm();
    if (this.companyId > 0) {
      this.getCompanyDetail(this.companyId);
    }
  }

  onInitCompanyForm() {
    this.CompanyForm = this.formBuilder.group({
      companyId: [0],
      CompanyName: ['', [Validators.required]],
      EmailId: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      MobileNo: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      Address: ['', [Validators.required]],
      CompanyWebsite: ["", [Validators.required, Validators.pattern(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/)]],
      CompanyLogo: [''],
      CompanyAbout: ['', [Validators.required]],
      CompanyType: ['', [Validators.required]],
      CompanySize: ['', [Validators.required]],
    });
  }

  get companyFormControl() {
    return this.CompanyForm.controls;
  }

  getCompanyDetail(companyId: number) {
    const apiUrl = this.apiUrl.apiUrl.company.GetCompanyById.replace("{id}", companyId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data.data.companyLogo) {
          (<HTMLInputElement>document.getElementById("companyProfilePreview")).setAttribute("src", data.data.companyLogo);
        }
        else {
          (<HTMLInputElement>document.getElementById("companyProfilePreview")).setAttribute("src", "../../../../../assets/img/logo_placeholder.svg");
        }
        this.spinner.hide()
        this.setCompanyForm(data.data);
      },
      error: (err) => {
        console.log('GetCompanyById-Error', err);
      }
    });
  }

  setCompanyForm(data) {
    this.CompanyForm.setValue({
      companyId: (data.companyId) ? data.companyId : 0,
      CompanyName: data.companyName,
      EmailId: data.emailId,
      MobileNo: data.mobileNo,
      Address: data.address,
      CompanyWebsite: data.companyWebsite,
      CompanyLogo: data.companyLogo ? data.companyLogo : '',
      CompanyAbout: data.companyAbout ? data.companyAbout : '',
      CompanyType: data.companyType ? data.companyType : '',
      CompanySize: data.companySize ? data.companySize : ''
    });
  }

  saveCompany() {
    this.submittedCompanydetail = true;
    if (!this.CompanyForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    form.append('companyId', this.CompanyForm.value.companyId ? this.CompanyForm.value.companyId.toString() : '0');
    form.append('companyName', this.CompanyForm.value.CompanyName.trim());
    form.append('companyWebsite', this.CompanyForm.value.CompanyWebsite.trim());
    form.append('emailId', this.CompanyForm.value.EmailId.trim());
    form.append('mobileNo', this.CompanyForm.value.MobileNo.trim());
    form.append('address', this.CompanyForm.value.Address.trim());
    form.append("companyPhoto", this.userPhotoFile);
    form.append("companylogo", this.companyLogo);
    form.append('companyAbout', this.CompanyForm.value.CompanyAbout.trim());
    form.append('companyType', this.CompanyForm.value.CompanyType.trim());
    form.append('companySize', this.CompanyForm.value.CompanySize.trim());
    const apiUrl = this.apiUrl.apiUrl.company.SaveCompany;
    this.commonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.toastr.success(data.message);
          this.router.navigate(['../']);
          this.spinner.hide();
        }
        else {
          this.toastr.error(data.message);
          this.spinner.hide();
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  onCancel() {
    this.router.navigate(['../']);
  }



  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Please select only JPG, JPEG or PNG image");
          (<HTMLInputElement>document.getElementById('uploadCompanyImage')).value = "";
          return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById("companyProfileName")).innerHTML = event.target.files[0].name;
        (<HTMLInputElement>document.getElementById("companyProfilePreview")).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.userPhotoFile = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById("companyProfilePreview")).setAttribute("src", "../../../../../assets/img/logo_placeholder.svg");
      this.userPhotoFile = null;
      (<HTMLInputElement>document.getElementById('uploadCompanyImage')).value = '';
      this.CompanyForm.controls['CompanyLogo'].setValue('');
    }
  }
}
